import { render, staticRenderFns } from "./Triggers.vue?vue&type=template&id=dc636806&scoped=true"
import script from "./Triggers.vue?vue&type=script&lang=js"
export * from "./Triggers.vue?vue&type=script&lang=js"
import style0 from "./Triggers.vue?vue&type=style&index=0&id=dc636806&prod&lang=scss&scoped=true"
import style1 from "./Triggers.vue?vue&type=style&index=1&id=dc636806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc636806",
  null
  
)

export default component.exports